import { ContentAnimation } from './contentAnimation';
import { ContentType, IContentOptions } from './content';
import { SystemLayer } from '../System/systemLayer';
import { PatternMaterial } from './Pattern/Mesh/patternMaterial';
import { IMaterialOptions } from '../Tool/toolMaterial';

/*
  +------------------------------------------------------------------------+
  | MATERIAL CONTENT                                                       |
  +------------------------------------------------------------------------+
*/

export abstract class ContentMaterial extends ContentAnimation {
    public material: string;

    public patternMaterial: PatternMaterial;

    constructor(systemLayer: SystemLayer, content: IContentOptions, contentType: ContentType) {
        super(systemLayer, content, contentType);
        this.patternMaterial = this.pattern as PatternMaterial;
    }

    public setMaterial = (materialKey: string): void => {
        this.material = materialKey;
        const material = this._system.toolMaterial.getMaterialWithLinearSpaceByKey(materialKey);
        if (!material) return;

        // this parameters can be null due to undo but it will break the mesh
        if (material.alpha === null) material.alpha = 1;

        if (material.tintColor !== undefined) this.patternMaterial.setTintColor(material.tintColor);
        else this.patternMaterial.resetTintColor();

        this.patternMaterial.setTextureUrl('albedoTexture', material.albedoTexture);
        this.patternMaterial.setTextureUrl('metallicTexture', material.metallicTexture);
        this.patternMaterial.setTextureUrl('bumpTexture', material.bumpTexture);

        this.setMaterialProperties(material);
    }

    private setMaterialProperties(properties: IMaterialOptions) {
        const keys = Object.keys(properties);
        keys.forEach((key) => {
            this.patternMaterial.setMaterialProperty(key, properties[key]);
        });
    }
}
